<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <v-card>
      <v-card-title>
        <span
          v-if="!loading"
          v-t="{
            path: 'modals.businessInfo.title',
            args: { num: infos.num_pdv },
          }"
        ></span>
      </v-card-title>
      <v-card-subtitle v-t="'modals.businessInfo.subtitle'"></v-card-subtitle>

      <!-- <div class="loader text-center" v-if="loading">
            <v-progress-circular indeterminate color="primary" />
      </div>-->
      <v-skeleton-loader
        type="list-item-three-line,list-item-three-line,list-item-three-line"
        :loading="loading"
      >
        <v-expansion-panels accordion flat hover v-model="panels">
          <v-expansion-panel>
            <v-expansion-panel-header
              v-t="'modals.businessInfo.labels.generalInformations'"
            >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-if="infos">
                <v-col cols="6">
                  <dl>
                    <dt
                      v-if="mainFolder.code !== 'pt'"
                      v-t="'modals.businessInfo.labels.group'"
                    ></dt>
                    <dd v-if="mainFolder.code !== 'pt'">
                      <v-select
                        v-if="canEditBusinessGroup"
                        class="d-inline-block mb-2"
                        style="width: 120px"
                        v-model="group"
                        dense
                        hide-details
                        item-text="code"
                        item-value="id"
                        :items="businessGroups"
                        @change="updateBusinessGroup"
                      ></v-select>
                      <span v-else-if="businessGroup(group)">
                        {{ businessGroup(group).code }}
                      </span>
                      <span v-else class="text--secondary">
                        {{ $t("labels.empty.m") }}
                      </span>
                    </dd>
                    <dt v-t="'modals.businessInfo.labels.code'"></dt>
                    <dd>{{ infos.num_pdv }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.reference'"></dt>
                    <dd>{{ infos.reference }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.label'"></dt>
                    <dd>{{ infos.libelle }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.title'"></dt>
                    <dd>{{ infos.titre }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.address'"></dt>
                    <dd>{{ infos.adresse }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.postCode'"></dt>
                    <dd>{{ infos.cp }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.city'"></dt>
                    <dd>{{ infos.ville }}&nbsp;</dd>
                  </dl>
                </v-col>
                <v-col cols="6">
                  <dl>
                    <dt v-t="'modals.businessInfo.labels.email'"></dt>
                    <dd>{{ infos.email }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.tel'"></dt>
                    <dd>{{ infos.tel }}&nbsp;</dd>
                    <!--                    <dt v-t="'modals.businessInfo.labels.area'"></dt>-->
                    <!--                    <dd>{{ questions.surface }}&nbsp;</dd>-->
                    <!--                    <dt v-t="'modals.businessInfo.labels.employees'"></dt>-->
                    <!--                    <dd>{{ questions.nbemployes }}&nbsp;</dd>-->
                  </dl>
                </v-col>
              </v-row>
              <v-row v-if="infos">
                <v-col cols="12">
                  <dl>
                    <dt v-t="'modals.businessInfo.labels.stat'"></dt>
                    <dd>{{ infos.codstat }}&nbsp;</dd>
                    <dt v-t="'modals.businessInfo.labels.notes'"></dt>
                    <dd>{{ infos.note }}&nbsp;</dd>
                  </dl>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              v-t="'modals.businessInfo.labels.orderInformations'"
            >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-if="notes">
                <v-col cols="12">
                  <dl>
                    <dt v-t="'modals.businessInfo.labels.notes'"></dt>
                    <dd>{{ notes }}&nbsp;</dd>
                  </dl>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              v-t="'modals.businessInfo.labels.contacts'"
            ></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container class="scroll modal">
                <v-row
                  class="contact-row"
                  v-for="(contact, index) in contacts"
                  :key="`contactrow-${index}`"
                >
                  <v-col cols="12" v-if="index !== 0">
                    <v-divider />
                  </v-col>
                  <v-col cols="6">
                    <dl>
                      <dt>
                        <v-icon>mdi-account</v-icon>
                      </dt>
                      <dd>
                        {{ contact.titre_ct }} {{ contact.nom_ct }}
                        {{ contact.prenom_ct }}&nbsp;
                      </dd>
                      <dt>
                        <v-icon>mdi-briefcase-account</v-icon>
                      </dt>
                      <dd>{{ contact.fonction_ct }}&nbsp;</dd>
                      <dt>
                        <v-icon>mdi-at</v-icon>
                      </dt>
                      <dd>{{ contact.email_ct }}&nbsp;</dd>
                    </dl>
                  </v-col>
                  <v-col cols="6">
                    <dt>
                      <v-icon>mdi-phone</v-icon>
                    </dt>
                    <dd>{{ contact.tel_ct }}&nbsp;</dd>
                    <dt>
                      <v-icon>mdi-cellphone</v-icon>
                    </dt>
                    <dd>{{ contact.telgsm_ct }}&nbsp;</dd>
                    <dt>
                      <v-icon>mdi-fax</v-icon>
                    </dt>
                    <dd>{{ contact.fax_ct }}&nbsp;</dd>
                  </v-col>
                  <v-col cols="10">
                    <dt>
                      <v-icon>mdi-briefcase-account</v-icon>
                    </dt>
                    <dd>{{ contact.fonction | displayFunction }}&nbsp;</dd>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              v-t="'modals.businessInfo.labels.prestationsDone'"
            >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container class="scroll modal">
                <v-row
                  class="event-row"
                  v-for="(event, index) in calendarEvents"
                  :key="`eventrow-${index}`"
                >
                  <v-col cols="12" v-if="index !== 0">
                    <v-divider />
                  </v-col>
                  <v-col cols="6">
                    <dl>
                      <dt>
                        <v-icon>mdi-barcode</v-icon>
                      </dt>
                      <dd>
                        {{ event.subtype | removeDoss }} -
                        {{ eventTypeLabel(event.subtype) }}
                      </dd>
                      <dt>
                        <v-icon>mdi-clock-time-four</v-icon>
                      </dt>
                      <dd>{{ event.startAt | displayDate }}</dd>
                    </dl>
                  </v-col>
                  <v-col cols="3">
                    <dt>
                      <v-icon>mdi-state-machine</v-icon>
                    </dt>
                    <dd>{{ event.state | displayState }}</dd>
                    <dt>
                      <v-icon>mdi-timer-sand-full</v-icon>
                    </dt>
                    <dd>{{ event.duration | displayDuration }}</dd>
                  </v-col>
                  <v-col cols="3">
                    <dt>
                      <v-icon>mdi-account</v-icon>
                    </dt>
                    <dd>{{ event.participant }}</dd>
                    <dt>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-weight</v-icon>
                        </template>
                        <span v-t="'tooltips.quantity'"></span>
                      </v-tooltip>
                    </dt>
                    <dd>{{ event.quantity }}</dd>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              v-t="'modals.businessInfo.labels.prestationsUnplanned'"
            >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container class="scroll modal">
                <v-row
                  class="event-row"
                  v-for="(event, index) in cmdEvents"
                  :key="`eventrow-cmd-${index}`"
                >
                  <v-col cols="12" v-if="index !== 0">
                    <v-divider />
                  </v-col>
                  <v-col cols="6">
                    <dl>
                      <dt>
                        <v-icon>mdi-barcode</v-icon>
                      </dt>
                      <dd>
                        {{ event.subtype | removeDoss }} -
                        {{ eventTypeLabel(event.subtype) }}
                      </dd>
                      <dt>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-clock-time-four</v-icon>
                          </template>
                          <span v-t="'tooltips.deadline'"></span>
                        </v-tooltip>
                      </dt>
                      <dd>{{ event.deadline | displayDate }}</dd>
                    </dl>
                  </v-col>
                  <v-col cols="3">
                    <dt>
                      <v-icon>mdi-state-machine</v-icon>
                    </dt>
                    <dd>{{ event.state | displayState }}</dd>
                    <dt>
                      <v-icon>mdi-timer-sand-full</v-icon>
                    </dt>
                    <dd>{{ event.duration | displayDuration }}</dd>
                  </v-col>
                  <v-col cols="3">
                    <dt>
                      <v-icon>mdi-account</v-icon>
                    </dt>
                    <dd>{{ event.participant }}</dd>
                    <dt>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-weight</v-icon>
                        </template>
                        <span v-t="'tooltips.quantity'"></span>
                      </v-tooltip>
                    </dt>
                    <dd>{{ event.quantity }}</dd>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-skeleton-loader>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="closeModal"
          v-t="'actions.close'"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventApi from "@/api/events";
import * as getters from "@/store/getters";
import { mapGetters, mapState } from "vuex";
import { ENUM_ALL_STATE } from "@/tools/enum";
import { EventBus } from "@/tools/event-bus";
import {
  getLocalizedDatetimeFormat,
  getLocalizedDateFormat,
  getDurationFormat,
} from "@/tools/dateUtils";
import i18n from "@/plugins/i18n.js";

export default {
  name: "BusinessInfoModal",
  created() {
    EventBus.$on("key-abort", this.closeModal);
    EventBus.$on("open-business-info-modal", this.openModal);
  },
  methods: {
    closeModal: function () {
      this.dialog = false;
    },
    openModal: async function ({ eventId, businessId }) {
      this.dialog = true;

      try {
        this.businessId = businessId;

        const res = await eventApi.getBusinessInfo(eventId);

        this.infos = res.data.infosclient;
        this.questions = res.data.questionnaire;
        this.contacts = res.data.contactclient;
        this.calendarEvents = res.data["calendar_events"];
        this.cmdEvents = res.data["cmd_events"];
        this.panels = 0;
        this.notes = this.eventNotes(eventId);
        if (!this.notes) {
          const ret = await eventApi.loadEvent(eventId);

          this.group = ret.data.businessGroupId;
          this.notes = ret.data.description;
        }
        this.loading = false;
      } catch (error) {
        this.$noty.error(error.response.data.message);
        this.dialog = false;
      }
    },
    updateBusinessGroup(value) {
      eventApi.updateBusinessGroup(this.businessId, value);
    },
  },
  data() {
    return {
      panels: 0,
      dialog: false,
      loading: true,
      infos: undefined,
      questions: undefined,
      contacts: undefined,
      calendarEvents: undefined,
      cmdEvents: undefined,
      notes: undefined,
      group: undefined,
      businessId: undefined,
    };
  },
  filters: {
    removeDoss: (divaltoRef) => divaltoRef.substring(4),
    displayDate: (val) => getLocalizedDateFormat(val),
    displayDatetime: (val) => getLocalizedDatetimeFormat(val),
    displayDuration: (val) => getDurationFormat(val),
    displayState: (val) => {
      const state = ENUM_ALL_STATE.find((el) => el.value === val);
      if (state) {
        return i18n.t(`states.${state.value}`);
      }
      return val;
    },
    displayFunction: (val) => {
      if (!val) return "";

      if (Array.isArray(val)) {
        return val
          .map(
            (item) => i18n.t(`modals.businessInfo.functions.${item}`) || item
          )
          .join(", ");
      }

      return i18n.t(`functions.${val}`) || val.toString();
    },
  },
  computed: {
    ...mapGetters({
      eventTypeLabel: getters.EVENT_TYPE_LABEL,
      eventNotes: getters.EVENT_ORDER_NOTE,
      businessGroups: getters.BUSINESS_GROUPS,
      businessGroup: getters.BUSINESS_GROUP,
      isImpersonateAdmin: getters.IS_IMPERSONATE_ADMIN,
      mainFolder: getters.MAIN_FOLDER,
    }),
    ...mapState({
      customerRoles: (state) => state.customer.roles,
    }),

    canEditBusinessGroup() {
      return !!(
        this.mainFolder.code !== "pt" &&
        (this.customerRoles.includes("ROLE_ADMIN") || this.isImpersonateAdmin)
      );
    },
  },
};
</script>

<style scoped>
.event-row dt {
  width: 3em;
}

.contact-row dt {
  width: 2.2em;
}

dt {
  float: left;
  clear: left;
  width: 6em;
  font-weight: bold;
}

.v-divider {
  margin: 0 120px;
}

.container.scroll.modal {
  max-height: 50vh;
  padding-top: 0;
}

.event-row {
  font-size: 10pt;
}

.event-row .v-icon {
  font-size: 13pt;
}
</style>
